import { render } from "./Loading.vue?vue&type=template&id=14508630"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=14508630&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__